var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modals',{attrs:{"title":'Change Reason Comment',"display":_vm.display,"parentTag":'form',"novalidate":'novalidate'},on:{"show":_vm.close},scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('Textarea',{attrs:{"className":'textarea__input',"label":'What changed?',"placeholder":"Add a comment about the change","rows":5,"cols":30,"maxLength":200},model:{value:(_vm.form.message),callback:function ($$v) {_vm.$set(_vm.form, "message", $$v)},expression:"form.message"}})]},proxy:true},{key:"modal-footer",fn:function(){return [_c('ButtonGroup',{attrs:{"items":[
				{
					id: 'saveButtonModal',
					className: 'btn--primary',
					labelText: 'Save Reason',
					type: 'submit',
					btnClick: _vm.saveComment,
					disabled: !_vm.form.message
				},
				{
					id: 'cancelButtonModal',
					labelText: 'Proceed without Reason',
					btnClick: _vm.saveComment
				}
			]}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }